import React from 'react';
import { Box } from '@mui/material';
import { StatusColor } from './lib/types';
import { STATUS_COLORS, STATUS_LABEL } from './lib/selectors';

/**
 * The status dot (DASHBOARD.md §1.1). Colour is never the only signal: every dot
 * carries a text label as title and aria-label. Yellow has the spec's 2 px
 * #fef3c7 ring.
 */
export function StatusDot({ color, size = 10, label }: { color: StatusColor; size?: number; label?: string }) {
  const text = label || STATUS_LABEL[color];
  return (
    <Box
      component="span"
      role="img"
      aria-label={text}
      title={text}
      data-status={color}
      sx={{
        display: 'inline-block',
        width: size,
        height: size,
        borderRadius: '50%',
        flexShrink: 0,
        backgroundColor: STATUS_COLORS[color],
        ...(color === 'yellow' ? { boxShadow: '0 0 0 2px #fef3c7' } : {}),
      }}
    />
  );
}
